import Icon from "components/Common/Icon";
import { getEnchantName, getEnchantQuality, getEnchantQualityIconSrc, getEnchantImgLinkSrc, trimQuality } from "lib/enchant-ids";
import React from "react";
import WowTooltip from "../Tooltips/WowTooltip";

const WeaponItem = (props) => {
  const {
    enchantName,
    enchantId,
    itemName,
    itemColor,
    img,
    id,
    positionLeft,
    popularity,
    count,
    bonusIds,
    craftingQuality,
    gems,
  } = props;

  return (
    <div>
      <div className={`weapon-container ${!positionLeft ? "right-container" : ""}`}>
        <div className="weapon-item-container">
          <WowTooltip type="item" id={id} bonusIds={bonusIds} craftingQuality={craftingQuality} enchant={enchantId} gems={gems}>
            <Icon staticDataImg={img} classType="bis-item-icon" color={itemColor} />
          </WowTooltip>
          <div className="item-info">
            <div className="item-name" style={{ color: itemColor }}>
              {itemName}
            </div>
            <div className="enchant-info">
              {enchantName ? <Icon iconSize="18px" staticDataImg={getEnchantImgLinkSrc(enchantName)} /> : null}
              <div className="enchant-text">{trimQuality(getEnchantName(enchantName?.split(" (")[0]))}</div>
              {enchantName ? (
                <img
                  style={
                    getEnchantQuality(enchantName) == 2
                      ? { width: "16px", height: "8px", marginLeft: "4px" }
                      : { width: "16px", height: "12px", marginLeft: "4px" }
                  }
                  src={getEnchantQualityIconSrc(enchantName)}
                ></img>
              ) : null}
            </div>
          </div>
        </div>
        {popularity ? (
          <div className="popularity-container">
            <div className="popularity-value">{parseFloat(popularity).toFixed(1)}%</div>
            <div className="popularity-label">({count.toLocaleString("en-US")} players)</div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default WeaponItem;
